import { type ReactNode } from 'react'
import { Link } from 'react-router'
import logoWhite from '#app/assets/images/logos/100-logo-white.svg'
import { Icon } from '../ui/icon'

interface QuoteFlowLayoutProps {
	children: ReactNode
	currentStep: number
	totalSteps: number
	onBack?: () => void
	onClose?: () => void
	progressBar?: ReactNode
	mobileFooter?: ReactNode
}

export function QuoteFlowLayout({
	children,
	currentStep: _currentStep,
	totalSteps: _totalSteps,
	onBack,
	onClose,
	progressBar,
	mobileFooter,
}: QuoteFlowLayoutProps) {
	return (
		<div className="font-parkinsans flex min-h-screen flex-col bg-white md:min-h-[742px]">
			{/* Header with cyan background */}
			<div className="relative h-16 shrink-0 overflow-hidden bg-gradient-to-r from-blue-500 to-green-500 px-4 md:h-20 md:px-16">
				{/* Decorative lines background */}
				<div className="pointer-events-none absolute top-[-969px] left-[-264px] h-[calc(1px*((1501.6875*0.7071067690849304)+(1431.59375*0.7071067690849304)))] w-[calc(1px*((1431.59375*0.7071067690849304)+(1501.6875*0.7071067690849304)))] -rotate-45 opacity-10">
					<div className="h-full w-full bg-[repeating-linear-gradient(0deg,transparent,transparent_20px,white_20px,white_21px)]" />
				</div>

				{/* Header content */}
				<div className="relative flex h-full items-center justify-between">
					<div className="flex items-center gap-3">
						{onBack ? (
							<button
								onClick={onBack}
								className="flex cursor-pointer items-center justify-center"
								aria-label="Volver"
							>
								<Icon
									name="arrow-left-01-sharp"
									className="size-5 text-white"
								/>
							</button>
						) : onClose ? (
							<button
								onClick={onClose}
								className="flex items-center justify-center"
								aria-label="Cerrar"
							>
								<Icon name="cross-1" className="size-5 text-white" />
							</button>
						) : (
							<Icon name="arrow-left" className="size-5 text-white" />
						)}
						<div className="flex items-center gap-3 rounded-xl bg-blue-50 p-2">
							<Icon name="car-04" className="size-5 text-blue-800" />
						</div>
						<p className="font-parkinsans text-base font-medium text-white md:text-lg">
							Auto
						</p>
					</div>
					<Link to="/">
						<img
							src={logoWhite}
							alt="100prevalor"
							className="h-7"
							onError={(e) => {
								// Fallback if white logo doesn't exist
								e.currentTarget.src = '/img/logo-100prevalor.svg'
							}}
						/>
					</Link>
				</div>
			</div>

			{/* Main content - 16px padding */}
			<div className="flex flex-1 p-3 md:p-4">
				{/* Gray container - bg-neutral-100 with 24px border radius - takes full available space */}
				<div className="flex w-full flex-col items-center justify-center rounded-2xl bg-neutral-100 px-3 py-6 md:rounded-3xl md:px-4 md:py-8">
					{/* Content container - 1200px max width */}
					<div
						className={`flex w-full max-w-[1200px] flex-col gap-6 md:gap-8 ${mobileFooter ? 'pb-20 md:pb-0' : ''}`}
					>
						{progressBar}
						{children}
					</div>
				</div>
			</div>

			{/* Mobile footer - fijado abajo */}
			{mobileFooter && (
				<div className="fixed right-0 bottom-0 left-0 z-10 border-t border-neutral-400 bg-white px-6 py-3 md:hidden">
					{mobileFooter}
				</div>
			)}
		</div>
	)
}
